export default "__VITE_ASSET__jqDk4Snz__"